import GlobalTable from '@/src/constrains/BulkEditorTable/BulkEditorTable2';
import { useQueries, useSelectRows } from '@/src/tools/hooks/listPageHooks';
import { EnumTablePosition } from '@/src/types/common/common';
import { Tag, message } from 'antd';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { Image } from 'src/components/Antd';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import Link from 'src/components/Link/Link';
import { useI18n } from 'src/hooks/useRouterChange';
import SetAdjustion from 'src/pages/Inventory/List/Components/SetInventoryAdjust/SetInventoryAdjust';
import { convertProduct } from 'src/pages/Inventory/List/tools';
import { InventoryProduct } from 'src/pages/Inventory/List/type';
import {
  adjustInventory,
  getInventories,
  postInventories,
} from 'src/request/inventory/inventory';
import { I18N_KEY_MAPPING, defaultPageSize } from 'src/tools/constant';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { searchConditions as _searchConditions } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import { IInventory } from 'src/types/common/inventory';
import { EnumProductType, ProductItem } from 'src/types/common/product';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import { filterList, sortList } from './InventoryListConfig';
import css from './css.less';
import { EnumStatus } from 'src/types/common/product';

const customerConvertQuery = (filter) => {
  const re: any = {};
  if (filter.supplierUuid) {
    if (filter.supplierUuid.length > 0) {
      re.supplierUuids = filter.supplierUuid.map((i) => {
        const { value } = i;
        return value;
      });
    }
  }
  if (filter.salesChannel) {
    if (filter.salesChannel.length > 0) {
      re.salesChannel = filter.salesChannel[0].value;
    }
  }
  if (filter.productTypes) {
    if (filter.productTypes.length > 0) {
      re.productTypes = filter.productTypes.map((i) => {
        const { value } = i;
        return value;
      });
    }
  }
  if (filter.productStatuses) {
    if (filter.productStatuses.length > 0) {
      re.productStatuses = filter.productStatuses.map((i) => {
        const { value } = i;
        return value;
      });
    }
  }
  //if (customFilterTransfer) customFilterTransfer(filter, re);
  return re;
};

const AllList = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const canView = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Products,
        subCategory: EnumSubCategory.ProductsInventory,
        operation: EnumOperation.view_inventory_history,
      }),
    ],
  });
  const canViewProduct = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Products,
        subCategory: EnumSubCategory.Products,
        operation: EnumOperation.view_product_details_page,
      }),
    ],
  });
  const { warehouses } = props;
  // const warehouseCol=
  //const wUuid = warehouseUuid || null;
  const [inventoryProducts, setInventoryProducts] = React.useState([]);
  const [suppliers, setSuppliers] = React.useState([]);
  const [productSetModal, setProductSetModal] = React.useState(false);
  const [selectedProduct, setSelectedProduct] =
    React.useState<InventoryProduct>(null);

  const [loading, setLoading] = useState(true);
  const [current, setCurrent] = useState(0);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const defaultSearch = {
    ..._searchConditions,
    sort: sortList({ getI18n })[2],
  };
  const { queryProps, search } = useQueries(
    filterList(suppliers, { getI18n }),
    sortList({ getI18n }),
    customerConvertQuery,
    defaultSearch,
  );

  const {
    rowSelection,
    selectedRowKeys,
    selectedAll,
    setSelectedAll,
    // setMappedSelectedKeys,
    // setSelectedRowKeys,
  } = useSelectRows(inventoryProducts);

  const handleInventoryQueryResult = (inventories) => {
    const { totalCount, results } = inventories;
    const convertProducts: InventoryProduct[] = results.map((i) => {
      const { product, available, uuid, warehouseStocks } = i;

      return convertProduct(product, available, uuid, warehouseStocks);
    });
    setInventoryProducts(convertProducts);
    setLoading(false);
    setTotal(totalCount);
  };
  //console.log('warehouseUuid1', warehouseUuid);
  const body = { ...search };
  // 右上角按钮暂时不写事件

  useEffect(() => {
    if (!loading) {
      setLoading(true);
    }
    // console.log('warehouseUuid2', warehouseUuid);
    getInventories(current * pageSize, pageSize, body).then((res) => {
      const { inventories, suppliers } = res;
      handleInventoryQueryResult(inventories);
      //console.log('inventories', inventories);
      setSuppliers(suppliers);
    });
  }, []); //进入页面
  const updateProducts = (cb) => {
    if (!loading) {
      setLoading(true);
    }
    postInventories(current * pageSize, pageSize, body).then((inventories) => {
      handleInventoryQueryResult(inventories);
    });
  };

  useAfterDidMountEffect(() => {
    updateProducts(() => {
      console.log('updateProducts');
    });
  }, [current]);
  useAfterDidMountEffect(() => {
    if (!current) {
      updateProducts(() => {
        console.log('getProduct');
      });
    } else {
      setCurrent(0);
    }
  }, [pageSize, search]);

  const modalOnCancel = () => {
    setProductSetModal(false);
  };
  const modalOnClose = () => {
    setSelectedProduct(null);
  };
  const modalOnOk = (uuid, inventoryUuid, detailOp, value, notes) => {
    const index = inventoryProducts.findIndex(
      (i) => i.inventoryUuid === inventoryUuid,
    );
    if (_.isNumber) {
      adjustInv(uuid, inventoryUuid, detailOp, value, notes, index, () => {
        modalOnCancel();
      });
    } else {
      message.warn(getI18n('general.error'));
    }
    //
  };

  const adjustInv = (
    uuid,
    inventoryUuid,
    detailOp,
    value,
    notes,
    index,
    cb?,
  ) => {
    // message.loading('Saving');
    const body = {
      productUuid: uuid,
      inventoryUuid,
      detailOp,
      value,
      notes,
      // warehouseUuid,
    };
    adjustInventory(body).then((inventory: IInventory<ProductItem>) => {
      const { product, available, uuid, warehouseStocks } = inventory;
      const _product = convertProduct(
        product,
        available,
        uuid,
        warehouseStocks,
      );

      const _i = _.cloneDeep(inventoryProducts);

      _i.splice(index, 1, _product);
      setInventoryProducts(_i);
      if (cb) cb();
      message.destroy();
      message.success(getI18n('general.status.saved'));
    });
  };
  const columns = React.useMemo(() => {
    const warehousesCol = warehouses.map((w) => {
      const { uuid, locationName } = w;
      return {
        textTitle: locationName,
        titleGenerate: () => {
          return (
            <NoWrapContainer>
              <Tooltip title={locationName}>{locationName}</Tooltip>
            </NoWrapContainer>
          );
        },

        //dataIndex: 'stock',
        position: EnumTablePosition.mid,
        default: true,
        optional: true,
        key: uuid,
        minWidth: 100,
        childGenerate: (text, record, index) => {
          //  console.log('record', record);
          const { warehouseStocks } = record;
          const target = (warehouseStocks || []).find(
            (i) => i.warehouseUuid === uuid,
          );
          const stock = _.get(target, 'available', 0);
          return (
            <NoWrapContainer>
              <Tooltip title={stock}>{stock}</Tooltip>
            </NoWrapContainer>
          );
        },
      };
    });
    return [
      {
        title: '',
        dataIndex: 'thumbnailUrl',
        key: 'thumbnailUrl',
        default: true,
        optional: false,
        className: css.columnClass,
        childGenerate: (url) => (
          <Image key={url} src={url} width={40} height={40} />
        ),
        width: 64,
        // fixed: 'left',
      },
      {
        //fixed: 'left',
        title: getI18n('general.sKU'),
        dataIndex: 'sku',
        default: true,
        optional: false,
        key: 'sku',
        className: css.columnClass,
        minWidth: 128,
      },
      {
        //fixed: 'left',
        title: getI18n('general.productName'),
        dataIndex: 'name',
        default: true,
        optional: false,
        key: 'name',
        className: css.columnClass,
        minWidth: 160,
        childGenerate: (text, record) => {
          const { productType, uuid, name } = record;
          const urlDict = {
            [EnumProductType.Simple]: 'simpleProduct',
            [EnumProductType.Set]: 'productSet',
            [EnumProductType.Service]: 'virtualProduct',
            [EnumProductType.GiftCard]: 'virtualProduct',
            [EnumProductType.Variant]: 'variantProduct',
          };

          return (
            <NoWrapContainer>
              {canViewProduct ? (
                <Link
                  className={css.link}
                  to={`/product/${urlDict[productType]}/${uuid}`}>
                  <Tooltip title={name}>{name}</Tooltip>
                </Link>
              ) : (
                <Tooltip title={name}>{name}</Tooltip>
              )}
            </NoWrapContainer>
          );
        },
      },
      {
        title: getI18n('general.type'),
        dataIndex: 'productType',
        default: true,
        optional: true,
        key: 'productType',
        className: css.columnClass,
        minWidth: 96, ///修改
      },
      {
        textTitle: getI18n('general.stock'),
        titleGenerate: () => {
          return getI18n('general.stock');
        },

        dataIndex: 'stock',
        position: EnumTablePosition.right,
        default: true,
        optional: true,
        key: 'stock',
        minWidth: 100,
        childGenerate: (text, record, index) => {
          const { available } = record;
          return (
            <NoWrapContainer>
              <Tooltip title={available}>{available}</Tooltip>
            </NoWrapContainer>
          );
        },
      },
      ...warehousesCol,

      {
        textTitle: getI18n('general.status'),
        titleGenerate: () => {
          return getI18n('general.status');
        },
        dataIndex: 'status',
        default: true,
        optional: true,
        position: EnumTablePosition.mid,
        childGenerate: (tags) => {
          let color = 'default';
          if (tags == EnumStatus.Draft) {
            color = 'warning';
          }
          if (tags == EnumStatus.Active) {
            color = 'success';
          }
          return (
            <Tag color={color} className={css.status}>
              {getI18n(I18N_KEY_MAPPING[tags])}
            </Tag>
          );
        },
        key: 'status',
        width: 88,
      },

      ...(canView
        ? [
            {
              fixed: 'right',
              title: getI18n('general.view'),
              dataIndex: 'View',
              default: true,
              optional: false,
              position: EnumTablePosition.mid,
              childGenerate: (tags, record) => {
                //console.log('record', record);
                const { uuid } = record;
                return (
                  <Link className={css.link} to={`/allInventory/${uuid}`}>
                    {getI18n('inventory.inventory.history')}
                  </Link>
                );
              },

              key: 'status',
              width: 60,
            },
          ]
        : []),
    ];
  }, [inventoryProducts, warehouses, canView]);
  const buttonMenu = [
    //Bulk Edit
  ];

  const paginationProps = {
    defaultPageSize: pageSize,
    showQuickJumper: true,
  };

  return (
    <React.Fragment>
      {productSetModal && (
        <SetAdjustion
          visible={productSetModal}
          onCancel={modalOnCancel}
          onOk={modalOnOk}
          maskClosable={false}
          productSet={selectedProduct}
          afterClose={modalOnClose}
          //warehouseUuid={warehouseUuid}
        />
      )}

      <GlobalTable
        hideBulkEditor
        id='InventoryListTable'
        queryProps={queryProps}
        dataSource={inventoryProducts}
        columns={columns}
        selectedAll={selectedAll}
        setSelectedAll={setSelectedAll}
        buttonMenu={buttonMenu}
        rowKey='uuid'
        pagination={paginationProps}
        current={current}
        setCurrent={setCurrent}
        pageSize={pageSize}
        setPageSize={setPageSize}
        total={total}
        rowSelection={rowSelection}
        selectedRowKeys={selectedRowKeys}
        // mappedSelectedKeys={mappedSelectedKeys}
        hidePagination={total == 0}
        loading={loading}
      />
    </React.Fragment>
  );
};

export default AllList;
